import { CircularProgress } from '@mui/material';
import { useAppContext } from 'app/AppContext';
import React, { useState } from 'react'
import Filtros from './Filtros'
import TabelaLaudos from './TabelaLaudos';
import TabContainer from 'components/tabs/TabContainer';
import TabPanel from 'components/tabs/TabPanel';
import GraficosIndicadores from './GraficosIndicadores';

export default function LaudoVisitaConsultaRelatorios() {

  const { useSetTitle } = useAppContext();
  const [laudos, setLaudos] = useState();
  const [apontamentosPorTipo, setApontamentosPorTipo] = useState();
  const [globalLoading, setGlobalLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useSetTitle("Relatórios");

  const handleStatusChange = () => {
    // force a new search when the status is changed
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <div style={{ display: "flex", flexDirection: 'column', flex: 1 }}>
      <Filtros
        laudos={laudos}
        setLaudos={setLaudos}
        setGlobalLoading={setGlobalLoading}
        apontamentosPorTipo={apontamentosPorTipo}
        setApontamentosPorTipo={setApontamentosPorTipo}
        refreshTrigger={refreshTrigger}
      />
      {laudos && <>

        <TabContainer>
          <TabPanel label="Laudos" sx={{ m: 2 }}>
            {globalLoading
              ? <div style={{ textAlign: "center", }}><CircularProgress /> {globalLoading}</div>
              : <TabelaLaudos laudos={laudos} onStatusChange={handleStatusChange} />
            }
          </TabPanel>
          <TabPanel label="Gráficos" sx={{ m: 2 }}>
            {globalLoading
              ? <div style={{ textAlign: "center", }}><CircularProgress /> {globalLoading}</div>
              : <GraficosIndicadores apontamentosPorTipo={apontamentosPorTipo} />
            }
          </TabPanel>
        </TabContainer>

      </>}
    </div>
  )
}
